module.exports = __webpack_public_path__ + "assets/7341e990ef7dc4c225ea4453bc09a610.png";